import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconSheet",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], h = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.5 1A1.5 1.5 0 0 0 1 2.5v7A1.5 1.5 0 0 0 2.5 11h7A1.5 1.5 0 0 0 11 9.5v-7A1.5 1.5 0 0 0 9.5 1h-7ZM2 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5V4H2V2.5ZM2 5v2h2V5H2Zm5 0v2H5V5h2ZM2 9.5a.5.5 0 0 0 .5.5H4V8H2v1.5Zm5 .5H5V8h2v2Zm2.5 0a.5.5 0 0 0 .5-.5V8H8v2h1.5Zm.5-5v2H8V5h2Z",
  fill: "currentColor"
}, null, -1), _ = [
  h
];
function m(a, u, i, v, f, e) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--sheet"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Sheet",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, _, 10, c);
}
const Z = /* @__PURE__ */ o(s, [["render", m]]);
export {
  Z as default
};
//# sourceMappingURL=sheet.js.map
